export const CUSTOM_FIELD_TYPES = {
  BREX_TOKEN: 'BREX_TOKEN',
} as const;
